import * as React from "react";
import { Create, SimpleForm, required, SelectInput } from "react-admin";
import {
  PAYMENT_GATEWAY_STATUSES,
  PAYMENT_GATEWAYS,
} from "@local/constants/index.js";
import { CustomToolbar } from "../../shared/components/index.js";

const createPaymentGateway = () => (
  <Create redirect="show">
    <SimpleForm toolbar={<CustomToolbar />}>
      <SelectInput
        source="name"
        validate={[required()]}
        choices={Object.keys(PAYMENT_GATEWAYS).map((payment_gateway) => {
          console.log(payment_gateway);
          return {
            id: payment_gateway,
            name: payment_gateway,
          };
        })}
      />
      <SelectInput
        source="status"
        validate={[required()]}
        choices={Object.keys(PAYMENT_GATEWAY_STATUSES).map((status) => ({
          id: status,
          name: `resources.PaymentGateway.source.status.${status}`,
        }))}
      />
    </SimpleForm>
  </Create>
);

export default createPaymentGateway;
